import React from 'react';
import { Column } from 'primereact/column';
import { useEpdProductOtherDangerMaterials } from 'services/api/queries';
import { HeaderCaptionSemiBold } from 'styles/v2/Styles.styled';
import { DataTableStyled } from '../StyledGrid';
import { EPDContentDeclarationProductType } from 'types/content-declaration/EPDContentDeclarationProductType';
import { useContentDeclarationTerminologyHelper } from '../../hooks/useContentDeclarationTerminologyHelper';
import { numericCellBody } from '../GridService';

interface Props {
  epdVersionId: string;
  contentDeclarationType: EPDContentDeclarationProductType;
  className?: string;
}

const header = (
  <HeaderCaptionSemiBold className="white-space-nowrap">
    Other hazardous and toxic substances if required by normative standards or regulation
  </HeaderCaptionSemiBold>
);

const OtherDangerMaterialsGridPdf: React.FC<Props> = ({ epdVersionId, contentDeclarationType, className }) => {
  const rows = useEpdProductOtherDangerMaterials(epdVersionId, contentDeclarationType).data;
  const { replaceInString } = useContentDeclarationTerminologyHelper();

  const isEmpty = !rows || !rows.some((d) => d.name || d.ecNo || d.casNo || d.weightPercent !== null);
  if (isEmpty) {
    return null;
  }

  return (
    <DataTableStyled
      className={className}
      header={header}
      value={rows}
      dataKey="ord"
      tableStyle={{ minWidth: '49rem', tableLayout: 'fixed' }}
      style={{ overflow: 'auto', display: 'grid' }}
      showGridlines
    >
      <Column field="name" header="Hazardous/Toxic substances" style={{ wordBreak: 'break-all' }} />
      <Column field="ecNo" header="EC No." style={{ width: '7rem' }} />
      <Column field="casNo" header="CAS No." style={{ width: '7rem' }} />
      <Column
        field="weightPercent"
        header={replaceInString('Weight per functional or declared unit %')}
        style={{ width: '15rem' }}
        body={numericCellBody()}
      />
    </DataTableStyled>
  );
};

export default OtherDangerMaterialsGridPdf;
